import { render, staticRenderFns } from "./socialMediaRow.vue?vue&type=template&id=63d4a8f3&scoped=true&"
import script from "./socialMediaRow.vue?vue&type=script&lang=js&"
export * from "./socialMediaRow.vue?vue&type=script&lang=js&"
import style0 from "./socialMediaRow.vue?vue&type=style&index=0&id=63d4a8f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d4a8f3",
  null
  
)

/* custom blocks */
import block0 from "./socialMediaRow.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VIcon,VRow,VTooltip})
